import { Coord, GridConfig } from "../../../../../../../src/types/Interface";
import rotateCoordinate from "../../../../../../../src/utils/coord/rotateCoordinate";


export default function genRandomlyRotation(gridConfig: GridConfig, startPoint: Coord, pivotPoint: Coord, offsets: number[]): number {
  const radians = [Math.PI / 2, -Math.PI / 2, -Math.PI];
  const u = gridConfig.width / gridConfig.cellSize - offsets[2];
  const v = gridConfig.height / gridConfig.cellSize - offsets[3];

  const possibleRadianIndexs = [...radians]
    .map(r => rotateCoordinate(startPoint, pivotPoint, r))
    .map((c, cI) => (c.x < u && c.x > offsets[0] + 2 && c.y < v && c.y > offsets[1] + 2) ? cI : null)
    .filter(e => e !== null);
  const randomIndex = possibleRadianIndexs[Math.floor(Math.random() * possibleRadianIndexs.length)];
  return radians[randomIndex];
}